import { IComponentOptions } from 'angular';

export const ToolGroupItemComponent: IComponentOptions = {
  template: require('./tool-group-item.html'),
  bindings: {
    tool: '=',
  },
};

angular.module('nv.directives.tool-group').component('nvToolGroupItem', ToolGroupItemComponent);
